/**
 * Created by andrey on 14.03.18.
 */

const HintButtonBooster = BaseButtonBooster.extend({
    ctor: function (booster) {
        this._super({
            booster,
            styles: cleverapps.styles.HintButtonBooster
        });

        this.setLocalZOrder(cleverapps.styles.HintButtonBooster.zOrder);
    },

    getForceHighlights: function () {
        return [cleverapps.Scenes.GetSceneComponent(WordGameSceneComponent).boardView];
    }
});

cleverapps.styles.HintButtonBooster = {
    width: 250,
    height: 110,
    zOrder: 0,

    position: [
        { x: { align: "right", dx: -15 }, y: { align: "bottom", dy: 350 } },
        { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 300 } },
        { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 300 } }
    ],

    scale: [0.9, 1, 1],

    content: {
        margin: 10,
        direction: cleverapps.UI.HORIZONTAL,
        freeBlock: {
            textWidth: 120
        },
        layout: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        }
    }
};